export const RISKIFIED_STATUS_USE: {[key: string]: string} = {
    approved: 'Approved',
    declined: 'Declined',
};
